import React from "react";

const Footer = () => {
  return (
    <div className="sb-sidenav-footer">
      <small> &copy; Hello Super Stars {new Date().getFullYear()} </small>
    </div>
  );
};

export default Footer;
